import { render, staticRenderFns } from "./Chart2.vue?vue&type=template&id=3d49cfb4&scoped=true"
import script from "./Chart2.vue?vue&type=script&lang=js"
export * from "./Chart2.vue?vue&type=script&lang=js"
import style0 from "./Chart2.vue?vue&type=style&index=0&id=3d49cfb4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d49cfb4",
  null
  
)

export default component.exports